import { create } from 'zustand';

export interface ViewStateStore {
  open: boolean;
  setOpen: (open: boolean) => void;
  toggle: () => void;
}

export const [useViewStateStore, ViewStateStoreApi] = create<ViewStateStore>(
  set => ({
    open: false,
    setOpen: open => set({ open }),
    toggle: (): void => {
      set(state => (state.open = !state.open));
    }
  })
);
